// The four sections that used to be four separate sidebar buttons, now tabs
// inside a single "Usuarios" section.
//
// Shared between the sidebar (containers/DefaultLayout/DefaultLayout.js) and the
// page itself, because they have to agree on two things: which permission opens
// which tab, and what order they appear in — the sidebar link points at the
// FIRST tab the person is allowed to open, so a coordinator (who has Estudiantes
// but not Usuarios) lands somewhere useful instead of on an empty page.
//
// The paths are the original ones on purpose. Nothing in the app links to them,
// but Ernesto and his staff have bookmarks, and keeping them means the browser
// back button still steps through tabs the way people expect.
export const PERSONAS_TABS = [
  { key: "NAV_ESTUDIANTES", label: "Estudiantes", path: "/students" },
  { key: "NAV_MAESTROS", label: "Maestros", path: "/teachers" },
  { key: "NAV_USUARIOS", label: "Usuarios", path: "/users" },
  { key: "NAV_ARCHIVADOS", label: "Archivados", path: "/archived" },
];

// Every path the consolidated section owns.
export const PERSONAS_PATHS = PERSONAS_TABS.map((t) => t.path);

// The sidebar entry's own url. Rewritten per-user to the first allowed tab.
export const PERSONAS_NAV_URL = "/users";
